// @ts-nocheck
import React, { useCallback, useState } from 'react';
import { Grid, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import PreviewTableChart from '../../ModelInventoryAndAssociation/PreviewTableChart';
import useModalDisclosure from '../../../../hooks/useModalDisclosure';

const ViewTable = ({ value, attribute }) => {
  const {
    open: openPreview,
    handleOpen: openModal,
    handleClose: closeModal,
  } = useModalDisclosure();

  const [previewItem, setPreviewItem] = useState({});

  const handleClosePreview = useCallback(() => {
    closeModal();
  }, [closeModal]);

  const handleOpenPreview = useCallback(() => {
    openModal();
    setPreviewItem({
      item: value,
      type: 'table',
      title: attribute?.label || 'Default Table',
    });
  }, [openModal, setPreviewItem, value]);

  return (
    <Grid container xs={12}>
      <Grid item xs={12}>
        <Typography
          variant="body2"
          component="span"
          onClick={handleOpenPreview}
          sx={{
            color: 'primary.main',
            cursor: 'pointer',
            textDecoration: 'underline',
          }}
        >
          View {attribute?.label || 'Table'}
        </Typography>
      </Grid>
      <PreviewTableChart
        open={openPreview}
        handleClose={handleClosePreview}
        previewItem={previewItem}
      />
    </Grid>
  );
};

ViewTable.propTypes = {
  value: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object])).isRequired,
  attribute: PropTypes.shape({
    label: PropTypes.string,
  }),
};

export default ViewTable;
